import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

import { AlertModule } from '../alert/alert.module';

import { PaymentFormComponent } from './payment-form.component';
import { AdyenCustomCardModule } from '../adyen-custom-card/adyen-custom-card.module';

import { RegisteredCreditCardsModule } from '../registered-credit-cards/registered-credit-cards.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
    imports: [
        CommonModule,
        MatDividerModule,
        
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTabsModule,
        MatTooltipModule,
        AlertModule,
        MatRadioModule,
        MatSlideToggleModule,
        AdyenCustomCardModule,
        RegisteredCreditCardsModule
    ],
  exports: [
    PaymentFormComponent
  ],
  providers: [
    provideNgxMask()
  ],
  declarations: [
    PaymentFormComponent
  ]
})
export class PaymentFormModule { }
